export default __webpack_public_path__ + "static/closed-7122430c01251e010c7e99bf1462fab8.png";